import Grid from "@cloudscape-design/components/grid";
import Summary from "./components/Summary";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import VehicleList from "./components/vehicle-list-table";
// import { VehicleMasterTable } from "./components/data list vehicle/data";
import { VehicleMasterTable } from "../w_vehicles/data";
import React, { useEffect, useState } from "react";
import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  ColumnLayout,
  Container,
  ContentLayout,
  Header,
  HelpPanel,
  Link,
  SpaceBetween,
  Spinner,
  SplitPanel,
} from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import { Navigation } from '../../../components/app/Navigation';
import { listVehicles } from "../../../graphql/queries";
import { ListVehiclesQueryVariables } from "../../../API";
import { fetchAuthSession } from "aws-amplify/auth";
import DashboardTyre from "../../w_tyre_services/dashboard_tyre";

Amplify.configure(config);



function DashboardVehicle() {
  //const [total_tyre, updateTotal_tyre] = useState(0);
  const [totalTyre, setTotalTyre] = useState(0);
  const [total_vehicle, updateTotal_vehicle] = useState(0);
  const [activeHref, setActiveHref] = React.useState("/");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [vehicleList, setVehicleList] = useState<VehicleMasterTable[]>([]);
  const [UserGroup, setUserGroup] = useState("");
  const [isLoading, setIsLoading] = React.useState(true);




  async function checkUserGroup() {
    try {
      const { tokens } = await fetchAuthSession();
      console.log("User belongs to the following groups:", tokens?.accessToken.payload["cognito:groups"]);
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  }
  //console.log("test",vehicleList)

  //graphql apis
  useEffect(() => {
    //currentAuthenticatedUser();
    checkUserGroup();
    fetchOverview();

  }, []);

  async function fetchOverview(limit = 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allVehicles: VehicleMasterTable[] = [];

      do {
        const variables: ListVehiclesQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listVehicles,
          authMode: 'userPool',
          variables,
        });

        const vehicles = response.data.listVehicles.items;
        nextToken = response.data.listVehicles.nextToken ?? null;  // Ensure nextToken is either string or null

        const newVehicles: VehicleMasterTable[] = vehicles.map((vehicle: any) => {
          const formattedTimestamp = new Date(vehicle.updatedAt).toLocaleString();

          return {
            id: vehicle.id,
            VehicleCode: vehicle.vehiclecode ?? "",
            TypeVehicle: vehicle.typevehicle ?? "",
            Location: vehicle.location ?? "",
            Category: vehicle.category ?? "",
            Status: Boolean(vehicle.status),
            Timestamps: formattedTimestamp ?? "",
          }
        });

        allVehicles = [...allVehicles, ...newVehicles];
      } while (nextToken);

      setVehicleList(allVehicles);
      updateTotal_vehicle(allVehicles.length);
      setIsLoading(false);
      //console.log(allVehicles);
    } catch (err) {
      console.log("error fetching vehicles: ", err);
    }
  }



  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles",
              },
              {
                text: "Overview",
                href: "/",
              },

            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref} adminSubMenuOpen={false} setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error('Function not implemented.');
            }}              // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name="external" />
                </h3>
                <ul>
                  <li>
                    <a href="">Link to documentation</a>
                  </li>
                  <li>
                    <a href="">Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant="h1"
                info={
                  <Link
                    variant="info"
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }

              >
                {activeHref === "/"
                  ? `Dashboard`
                  : ""}
              </Header>
            }
          >

            <div className="contentPlaceholder">
              <SpaceBetween size="l">
                <Grid gridDefinition={[
                  { colspan: { default: 12, xxs: 4 } },
                  { colspan: { default: 12, xxs: 8 } },
                  { colspan: { default: 12, xxs: 12 } },

                ]}
                >
                  <Container
                    header={
                      <Header variant="h2" description="Summary of total vehicles">
                        Overview
                      </Header>
                    }
                    fitHeight={true}
                  >

                    <ColumnLayout columns={2} variant="text-grid" minColumnWidth={120}>
                      <div>
                        <Box variant="awsui-key-label">Total Vehicles</Box>
                        <Link
                          variant="awsui-value-large"
                          href="#"
                          ariaLabel="Running instances (14)"
                        >
                          {total_vehicle}
                        </Link>
                      </div>
                      <div>
                        <Box variant="awsui-key-label">Total Tyres</Box>
                        <Link
                          variant="awsui-value-large"
                          href="#"
                          ariaLabel="Volumes (126)"
                        >{totalTyre}
                        </Link>
                      </div>
                    </ColumnLayout>
                  </Container>
                  <Summary />

                  {/* <Gmap /> */}
                  {isLoading ? (
                    <Box textAlign="center" >
                      <Spinner size="large" />
                      <Box variant="p">Loading vehicle data...</Box>
                    </Box>
                  ) : (
                    <VehicleList VehicleMaster={vehicleList} />
                  )}
                  {/* <Alarmtab data={dataUnit} />*/}

                </Grid>
              </SpaceBetween>
            </div>

          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header="Split panel header">
            Split panel content
          </SplitPanel>
        }
      />
      <div style={{ display: 'none' }}>
        <DashboardTyre onTotalTyreUpdate={setTotalTyre} />
      </div>
    </>

  );


}

export default DashboardVehicle;










